import { render, staticRenderFns } from "./ZDSpecNote.vue?vue&type=template&id=039eb047&"
import script from "./ZDSpecNote.vue?vue&type=script&lang=js&"
export * from "./ZDSpecNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports